import { Boxes, Layers } from "lucide-react"

import { SectionSidebarLayout } from "./SectionSidebarLayout"

export function InventorySectionLayout() {
  return (
    <SectionSidebarLayout
      navId="inventory"
      navItems={[
        { icon: Boxes, label: "Stock", to: "/inventory/stock" },
        { icon: Layers, label: "Lots", to: "/inventory/lots" },
      ]}
    />
  )
}
